import { BlurredCardProps } from './types';

import { classNames } from '@/shared/lib/classNames/classNames';

export const BlurredCard = ({ className, children }: BlurredCardProps) => (
  <div
    className={classNames({
      cls: 'rounded-20 bg-custom-surface-contrast-mid p-12 backdrop-blur-lg max-sm:pl-2',
      additional: [className],
    })}
  >
    {children}
  </div>
);
